import React, { useState } from 'react';
import { Badge, Box, Container, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';
import OrdersList from '../components/OrdersList';
import SpecialRequestsStaffTab from '../components/SpecialRequestsStaffTab';
import { useAuth } from '../context/AuthContext';
import { useOpenOrdersCount } from '../context/OpenOrdersCountContext';
import { hasPermission } from '../utils/permissions';

const Orders = () => {
  const { t } = useTranslation();
  const { userRole, customPermissions } = useAuth();
  const { openSpecialRequestsCount } = useOpenOrdersCount();
  const canManageOrders = hasPermission(userRole, 'manage_orders', customPermissions);
  const [tab, setTab] = useState(0);

  if (!canManageOrders) {
    return <OrdersList />;
  }

  return (
    <Layout>
      <Container maxWidth="xl" sx={{ px: { xs: 1, sm: 2 } }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}>
          <Tab label={t('orders.tabs.orders')} />
          <Tab
            label={(
              <Badge
                badgeContent={openSpecialRequestsCount}
                color="error"
                max={99}
                invisible={openSpecialRequestsCount === 0}
              >
                <Box component="span" sx={{ pr: openSpecialRequestsCount > 0 ? 1.5 : 0 }}>
                  {t('orders.tabs.specialRequests')}
                </Box>
              </Badge>
            )}
          />
        </Tabs>
        <Box sx={{ display: tab === 0 ? 'block' : 'none' }}>
          <OrdersList embedded />
        </Box>
        <Box sx={{ display: tab === 1 ? 'block' : 'none' }}>
          <SpecialRequestsStaffTab />
        </Box>
      </Container>
    </Layout>
  );
};

export default Orders;
